import { render } from "./PersonSectionRole.vue?vue&type=template&id=77a4c753"
import script from "./PersonSectionRole.vue?vue&type=script&lang=js"
export * from "./PersonSectionRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__